<!-- Contrast Checker card: the two colours (left), the two together with the ratio and the WCAG checks (right) -->
<div class="ct-card">
  <div class="ct-inputs">
    <div class="ct-field" *ngFor="let f of [ { key: 'fg', label: 'Text Color' }, { key: 'bg', label: 'Background Color' } ]; let first = first">
      <span class="ct-field-title">{{ f.label }}</span>
      <div class="ct-field-row">
        <span class="ct-swatch" [style.background-color]="f.key === 'fg' ? fg : bg">
          <input type="color" class="ct-swatch-pick" [ngModel]="( f.key === 'fg' ? fg : bg ).toLowerCase()"
                 (ngModelChange)="set( $any( f.key ), $event )" [attr.aria-label]="'Pick the ' + f.label.toLowerCase()"/>
        </span>
        <label class="ct-hex">
          <span class="ct-hash">#</span>
          <input type="text" class="ct-hex-input" maxlength="7" spellcheck="false" autocomplete="off" autocapitalize="off"
                 [ngModel]="f.key === 'fg' ? fgText : bgText" (ngModelChange)="onText( $any( f.key ), $event )"
                 (blur)="onBlur( $any( f.key ) )" [attr.aria-label]="f.label + ' hex code'"/>
        </label>
      </div>
      <button type="button" class="ct-swap" *ngIf="first" (click)="swap()" aria-label="Swap the text and background colors">
        <app-icon name="right-left" aria-hidden="true"></app-icon>Swap
      </button>
    </div>
  </div>

  <div class="ct-out">
    <div class="ct-preview" [style.background-color]="bg" [style.color]="fg">
      <p class="ct-sample-large">Large Text Reads Like This</p>
      <p class="ct-sample">Normal text at 16 pixels, the size most paragraphs on the web use. Every word should be easy to read.</p>
      <div class="ct-ui">
        <span class="ct-ui-btn" [style.border-color]="fg">Button</span>
        <span class="ct-ui-icon" [style.border-color]="fg" aria-hidden="true"><app-icon name="check"></app-icon></span>
        <span class="ct-ui-link">A link</span>
      </div>
    </div>

    <div class="ct-score">
      <div class="ct-ratio-block">
        <span class="ct-eyebrow">Contrast Ratio</span>
        <span class="ct-ratio">{{ ratioLabel }}<span class="ct-ratio-unit">:1</span></span>
        <span class="ct-verdict" [attr.data-level]="verdict">{{ verdict }}</span>
        <button type="button" class="ct-copy swap-label" (click)="copyRatio()" [attr.aria-label]="'Copy the ratio ' + ratioLabel + ':1'">
        <app-icon name="copy" aria-hidden="true"></app-icon><span>{{ copied ? 'Copied' : 'Copy Ratio' }}</span>
      </button>
      </div>
      <div class="ct-checks">
        <span class="ct-check" *ngFor="let c of checks" [class.pass]="c.pass">
          <app-icon [name]="c.pass ? 'check' : 'times'" aria-hidden="true"></app-icon>{{ c.label }} · {{ c.level }}
        </span>
        <span class="ct-check ct-check-apca" [class.pass]="apcaLabel !== 'Fail'">APCA Lc {{ apca }} · {{ apcaLabel }}</span>
      </div>
    </div>
  </div>
</div>
